const EMAIL_REGEX = /^([a-zA-Z0-9]+(?:(\.|-|_)[a-zA-Z0-9]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.){1,3}[a-zA-Z0-9]{2,}?)$/;
const USERNAME_REGEX = /^[\\@*\\_A-Za-z0-9\\-]{3,20}$/;
const USERNAME_REGEX_SUB = /([A-Za-z])/g;
const EMAIL_DOMAIN = /[^@]+$/g;

export { EMAIL_REGEX, USERNAME_REGEX, USERNAME_REGEX_SUB, EMAIL_DOMAIN };
